import React, { Fragment } from 'react';
import { X } from 'lucide-react';
interface PreviewModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function PreviewModal({
  isOpen,
  onClose,
  title,
  children
}: PreviewModalProps) {
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 overflow-y-auto" data-id="element-344">
      <div className="flex min-h-screen items-center justify-center p-4 text-center sm:p-0" data-id="element-345">
        {/* Backdrop */}
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" onClick={onClose} data-id="element-346" />

        {/* Modal Panel */}
        <div className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-4xl" data-id="element-347">
          <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4" data-id="element-348">
            <div className="flex items-center justify-between mb-4 border-b border-gray-200 pb-4" data-id="element-349">
              <h3 className="text-lg font-semibold leading-6 text-gray-900" data-id="element-350">
                {title}
              </h3>
              <button type="button" className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none" onClick={onClose} data-id="element-351">
                <X className="h-6 w-6" aria-hidden="true" data-id="element-352" />
              </button>
            </div>
            <div className="mt-2" data-id="element-353">{children}</div>
          </div>
        </div>
      </div>
    </div>;
}